import {getLidSize} from "../../containers/domain/lid";
import {setFirmHeight} from "./lidSlice";

type Thunk = (dispatch: any, getState: () => any) => void;

export const setInitialFirmHeight = (): Thunk => (dispatch, getState) => {
    const state = getState();
    const lidSize = getLidSize(state.plan);
    const height = lidSize.height;

    dispatch(setFirmHeight({height: height}));
};

